module.exports = __webpack_public_path__ + "img/img-10.a96e8ebe.webp";